import { inject, Injectable } from '@angular/core';
import { CanActivate, GuardResult, Router } from '@angular/router';
import { isAdmin } from '@marmon/shared/types/user';
import { AuthService } from '../services';

@Injectable({ providedIn: 'root' })
export class AdminGuard implements CanActivate {
	private readonly authService = inject(AuthService);
	private readonly router = inject(Router);

	canActivate(): GuardResult {
		const user = this.authService.user;
		if (user && isAdmin(user)) return true;
		return this.router.createUrlTree(['/analysis']);
	}
}
